import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NbTooltipModule } from '@nebular/theme'
import { ClipboardModule, ClipboardService } from 'ngx-clipboard'
/**
 * Represents a persona sharable link
 */
@Component({
  selector: 'ngx-sharable-link',
  templateUrl: './sharable-link.component.html',
  styleUrls: ['./sharable-link.component.scss'],
  imports: [CommonModule, NbTooltipModule, ClipboardModule]
})
export class SharableLinkComponent {
  /**
   * Link to share
   */
  @Input()
  link: string
  /**
   * Tooltip information
   */
  @Input()
  tooltip: string
  /**
   * Open the link in a new tab
   */
  @Input()
  openInNewTab = false
  /**
   * Link was copied
   */
  copied = false
  /**
   * Define the link type
   */
  @Input()
  linkType = 'NORMAL'
  /**
   * Link click emitter
   */
  @Output()
  clicked: EventEmitter<string>

  constructor(private clipboardService: ClipboardService) {
    this.clicked = new EventEmitter<string>()
  }
  /**
   * Mark this link as copied
   */
  share() {
    if (this.linkType === 'NORMAL') {
      this.clipboardService.copy(this.link)
      this.copied = true
      if (this.openInNewTab) {
        window.open(this.link, '_blank')
      }
    } else {
      this.clicked.emit(this.linkType)
    }
  }
  /**
   * Mouse moved outside the link component
   */
  mouseOut() {
    this.copied = false
  }
}
